import { render, staticRenderFns } from "./zhongyaoyinpian.vue?vue&type=template&id=a1b10842&"
import script from "./zhongyaoyinpian.vue?vue&type=script&lang=ts&"
export * from "./zhongyaoyinpian.vue?vue&type=script&lang=ts&"
import style0 from "./zhongyaoyinpian.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports